import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { FONTS } from 'styles/theme/fonts';
import { COLORS } from 'styles/theme/colors';

export const StackedText = ({ top, bottom }) => {
  const topText = top && top.length > 15 ? `${top.substring(0, 19)}...` : top;

  return (
    <StackedText.Container>
      <StackedText.Top title={top}>{topText} </StackedText.Top>
      <StackedText.Bottom>{bottom} </StackedText.Bottom>
    </StackedText.Container>
  );
};

StackedText.Container = styled.div`
  font-family: ${FONTS.default};
`;

StackedText.Top = styled(StackedText.Container)`
  font-size: 14px;
  line-height: 20px;
  color: ${COLORS.primaryText};
  letter-spacing: 0.25px;
  text-transform: uppercase;
`;

StackedText.Bottom = styled(StackedText.Container)`
  font-size: 12px;
  letter-spacing: 0.5px;
  line-height: 16px;
  text-transform: capitalize;
  color: ${COLORS.secondaryText};
`;

StackedText.propTypes = {
  top: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  bottom: PropTypes.string,
};

export default StackedText;
